import { memo } from 'react';
import { Overlay, Preloader } from '@wildberries/ui-kit';

type TProps = {
  isLoading: boolean;
};

export const PreLoader = memo(({ isLoading }: TProps) => {
  return (
    <Overlay
      absolute
      opacity="0.5"
      opened={isLoading}
      timeout={10}
      transparent
      whiteBackground
    >
      <Preloader color="rich-grey" size="medium" />
    </Overlay>
  );
});
